<template>
    <div>
        <tr>
            <td>
                <div class="font-btn-small">Auszuzahlender Betrag</div>
                <input type="text" class="font-input type-input font-normal" value="CHF 4500.00">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">E-Mail-Adresse des Paypal-Kontos</div>
                <input type="text" class="font-input type-input font-normal" value="Max Mustermann">
            </td>
        </tr>
        <tr>
            <td>
                <div class="font-btn-small">E-Mail-Adresse bestätigen</div>
                <input type="text" class="font-input type-input font-normal" value="CH90 6810 4036 5094 7">
            </td>
        </tr>
    </div>
</template>

<script>
  export default {}
</script>
